export default __webpack_public_path__ + "images/bgpk0.af8a690.jpg";